import { Component, ReactNode } from "react";
import { isModuleLoadError, reloadForModuleLoadFailure } from "@/lib/moduleRecovery";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  isChunkError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  componentDidMount() {
    // Module reload state is managed globally in moduleRecovery.ts.
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      isChunkError: isModuleLoadError(error),
    };
  }

  componentDidCatch(error: Error) {
    if (isModuleLoadError(error)) {
      reloadForModuleLoadFailure();
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError && !this.state.isChunkError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-dvh gap-4 p-6 text-center">
          <h2 className="text-xl font-semibold">Une erreur est survenue</h2>
          <p className="text-muted-foreground max-w-md">
            Quelque chose s&apos;est mal passé. Essayez de recharger la page.
          </p>
          <button
            onClick={this.handleReload}
            className="px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition"
          >
            Recharger
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
